import type { CSSProperties } from 'react';

import { Text } from '@actual-app/components/text';

import { separarEmoji } from './emoji';
import { colorCategoria, radio, suave } from './tokens';

type PildoraCategoriaProps = {
  nombre: string;
  /** Hueco 0..7 de `useColoresCategorias`; sin hueco, gris. */
  hueco?: number | null;
  tamano?: 'pequena' | 'normal';
  style?: CSSProperties;
  /** Marca para la ayuda con Gavi (qué parte enseña). */
  'data-ayuda'?: string;
};

/** Píldora de categoría: emoji + nombre sobre su color de categoría al 18 %. */
export function PildoraCategoria({
  nombre,
  hueco,
  tamano = 'normal',
  style,
  'data-ayuda': ayuda,
}: PildoraCategoriaProps) {
  const { emoji, resto } = separarEmoji(nombre);
  const tinta =
    hueco == null
      ? 'var(--p-fg-2, var(--color-pageTextLight))'
      : colorCategoria(hueco);
  const pequena = tamano === 'pequena';
  return (
    <Text
      data-ayuda={ayuda}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: pequena ? 4 : 6,
        minHeight: pequena ? 22 : 32,
        maxWidth: '100%',
        padding: pequena ? '0 8px 0 6px' : '0 12px 0 8px',
        borderRadius: radio.pildora,
        backgroundColor: suave(tinta),
        // Texto: el color de la categoría acercado a la tinta del tema para
        // que se lea igual en claro y en oscuro.
        color:
          hueco == null
            ? tinta
            : `color-mix(in oklab, ${tinta} 62%, var(--p-fg, var(--color-pageText)))`,
        fontWeight: 800,
        fontSize: pequena ? 11.5 : 13.5,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...style,
      }}
    >
      {emoji && <span aria-hidden>{emoji}</span>}
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {emoji ? resto : nombre}
      </span>
    </Text>
  );
}
